import { createContext, useContext } from 'react';
import type { Viewport } from '@livecontrol/core-ui';

/** Collapsed sidebar rail width (icon-only). */
export const RAIL_COLLAPSED = 72;

/** Expanded sidebar width (pinned or hovered). */
export const RAIL_EXPANDED = 224;

/** Fixed header height; used to offset the scrollable content below it. */
export const HEADER_HEIGHT = 84;

export interface Layout {
  readonly viewport: Viewport;

  /** Whether the sidebar is rendered at all; false on the standalone pages reached only by URL. */
  readonly sidebar: boolean;

  /** Sidebar is fixed open (persists across hovers). */
  readonly pinned: boolean;

  /** Sidebar is temporarily open because the pointer is over it. */
  readonly hovered: boolean;

  /** Sidebar is showing its expanded content (`pinned || hovered`). */
  readonly expanded: boolean;

  setPinned: (pinned: boolean) => void;
  setHovered: (hovered: boolean) => void;
}

export const LayoutContext = createContext<Layout>(<Layout>(<unknown>undefined));

export const useLayout = (): Layout => useContext(LayoutContext);
